import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderFloatingButtonService {
  private rendererFactory: RendererFactory2 = inject(RendererFactory2);
  public activeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public active$: Observable<boolean> = this.activeSubject.asObservable();
  public observer!: IntersectionObserver;
  public renderer: Renderer2 = this.rendererFactory.createRenderer(null, null);
  public targetStart = this.renderer.selectRootElement(
    '#order-button-start',
    true
  );
  public targetEnd = this.renderer.selectRootElement('#order-button-end', true);
  public windowHeight = this.renderer.selectRootElement('body', true)
    .scrollHeight;
}
